import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { openCookieSettings } from "../components/CookieConsent";
import { useI18n } from "../i18n/LanguageContext";

const ODR_URL = "https://ec.europa.eu/consumers/odr/";

// Wandelt Zeilenumbrüche (\n) eines Text-Segments in <br/> um.
function renderText(text, keyPrefix) {
  const parts = text.split("\n");
  return parts.map((line, i) => (
    <React.Fragment key={`${keyPrefix}-${i}`}>
      {line}
      {i < parts.length - 1 && <br />}
    </React.Fragment>
  ));
}

// Verarbeitet Platzhalter {{ODR_LINK}} und {{COOKIE_SETTINGS}} in einem Absatz.
function renderParagraph(text, idx, cookieLabel) {
  const nodes = [];
  const regex = /(\{\{ODR_LINK\}\}|\{\{COOKIE_SETTINGS\}\})/g;
  const segments = text.split(regex);
  segments.forEach((seg, i) => {
    if (seg === "{{ODR_LINK}}") {
      nodes.push(
        <a key={`odr-${idx}-${i}`} href={ODR_URL} target="_blank" rel="noopener noreferrer">
          {ODR_URL}
        </a>
      );
    } else if (seg === "{{COOKIE_SETTINGS}}") {
      nodes.push(
        <button
          key={`ck-${idx}-${i}`}
          type="button"
          onClick={openCookieSettings}
          className="text-blue-brand underline hover:no-underline"
        >
          {cookieLabel}
        </button>
      );
    } else if (seg) {
      nodes.push(<React.Fragment key={`t-${idx}-${i}`}>{renderText(seg, `${idx}-${i}`)}</React.Fragment>);
    }
  });
  return nodes;
}

const Wrap = ({ title, backHome, children }) => (
  <div className="pt-28 pb-24 bg-white min-h-screen" data-testid="legal-page">
    <div className="max-w-[820px] mx-auto px-5 lg:px-8">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-blue-brand hover:underline mb-6">
        <ArrowLeft size={16} /> {backHome}
      </Link>
      <h1 className="font-head font-extrabold text-ink text-4xl md:text-5xl mb-3">{title}</h1>
      <div className="w-20 h-1 rounded-full timeline-line mb-10" />
      <div className="prose-legal space-y-5 text-ink-soft leading-relaxed" style={{ color: "var(--ink-soft)" }}>
        {children}
      </div>
    </div>
  </div>
);

const H = ({ children }) => <h2 className="font-head font-bold text-ink text-xl mt-8 mb-2">{children}</h2>;

function LegalBlocks({ data, cookieLabel }) {
  return (
    <>
            {data.blocks.map((block, bi) => {

        return (
          <div key={bi}>
            <H>{block.h}</H>
            {(block.p || []).map((para, pi) => (
              <p key={pi}>{renderParagraph(para, `${bi}-${pi}`, cookieLabel)}</p>
            ))}
            {block.ul && (
              <ul className="list-disc pl-6 space-y-1">
                {block.ul.map((li, li2) => (
                  <li key={li2}>{li}</li>
                ))}
              </ul>
            )}
            {(block.pAfter || []).map((para, pi) => (
              <p key={`after-${pi}`}>{renderParagraph(para, `after-${bi}-${pi}`, cookieLabel)}</p>
            ))}
          </div>
        );
      })}
    </>
  );
}

export function Impressum() {
  const { t } = useI18n();
  const data = t.legal.impressum;
  return (
    <Wrap title={data.title} backHome={t.legal.backHome}>
      <LegalBlocks data={data} cookieLabel={t.legal.cookieSettingsLabel} />
    </Wrap>
  );
}

export function Datenschutz() {
  const { t } = useI18n();
  const data = t.legal.datenschutz;
  return (
    <Wrap title={data.title} backHome={t.legal.backHome}>
      <LegalBlocks data={data} cookieLabel={t.legal.cookieSettingsLabel} />
    </Wrap>
  );
}
